/*

  Twoletter.ts

  Two Letter Word display component

  Copyright (C) 2024 Miðeind ehf.
  Author: Vilhjalmur Thorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { IView } from "./types";
import { Vnode, ComponentFunc, m, VnodeChildren } from "./mithril";
import { ts } from "./i18n";

interface IAttributes {
  view: IView;
}

export const TwoLetter: ComponentFunc<IAttributes> = (initialVnode) => {

  // The two-letter-word list tab
  const view = initialVnode.attrs.view;
  const model = view.model;
  let page = 0;

  function renderWord(bold: boolean, w: string): Vnode {
    // For the first two-letter word in each group,
    // render the former letter in bold
    if (!bold)
      return m(".twoletter-word", w);
    if (page == 0)
      return m(".twoletter-word", [m("b", w[0]), w[1]]);
    else
      return m(".twoletter-word", [w[0], m("b", w[1])]);
  }

  return {
    view: () => {
      if (!model.game) return;
      const game = model.game;
      const twoLetters = game.twoLetterWords();
      const twoLetterWords = twoLetters[page];
      const twoLetterList: VnodeChildren = [];
      for (const tw of twoLetterWords) {
        const twl = tw[1];
        const sublist: VnodeChildren = [];
        for (let j = 0; j < twl.length; j++)
          sublist.push(renderWord(j == 0, twl[j]));
        twoLetterList.push(
          m(".twoletter-group", sublist)
        );
      }
      return m(".twoletter",
        {
          // Switch between pages when clicked
          onclick: () => { page = 1 - page; },
          style: "z-index: 6" // Appear on top of board on mobile
        },
        // Show the requested page
        m(".twoletter-area" + (game.showClock() ? ".with-clock" : ""),
          {
            title: page == 0 ?
              ts("Smelltu til að raða eftir seinni staf") :
              ts("Smelltu til að raða eftir fyrri staf")
          },
          twoLetterList
        )
      );
    }
  };
};
